import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'

import LabelWrapper from '../../LabelWrapper'

const styles = theme => ({
  text: {
    display: 'flex',
    minHeight: '36px',
    alignItems: 'center',
    fontSize: theme.typography.fontSizeSm,
    color: `var(--gameday-body-textColor, ${theme.body.textColor})`,
    '&.withLabel': {
      marginTop: '36px',
    },
    '&.withBorder': {
      padding: '6px 10px',
      border: theme.borders.default,
      borderRadius: theme.borders.borderRadius,
    },
    '&.fullWidth': {
      width: '100%',
    },
    '&.willDelete': {
      textDecoration: 'line-through',
      opacity: 0.6,
    },
    '&.disabled': {
      backgroundColor: `var(--gameday-inputField-inputBGDisabled, ${theme.inputField.inputBGDisabled})`,
      borderColor: `var(--gameday-inputField-inputBorderDisabled, ${theme.inputField.inputBorderDisabled})`,
      color: `var(--gameday-inputField-inputTextColorDisabled, ${theme.inputField.inputTextColorDisabled})`,
      '&:hover': {
        cursor: 'not-allowed',
      },
    },
  },
  labelWrapper: {
    '& .label-inline .withLabel': {
      marginTop: 0,
    },
    '&.bottomBorder': {
      borderBottom: theme.borders.default,
      '& .field-text': {
        padding: '6px 10px',
      },
    },
    '&.has-click .field-text:hover': {
      backgroundColor: `var(--gameday-inputField-inputBGHover, ${theme.inputField.inputBGHover})`,
      cursor: 'pointer',
    },
  },
  fieldDisplay: {
    padding: '6px 10px',
    color: `var(--gameday-body-textColor, ${theme.body.textColor})`,
    '&:hover:not(.withBorder)': {
      backgroundColor: `var(--gameday-inputField-inputBGHover, ${theme.inputField.inputBGHover})`,
    },
    '&.has-click:hover': {
      cursor: 'pointer',
    },
  },
})

const FieldText = ({
  bottomBorder,
  children,
  classes,
  className,
  customCol,
  customMargin,
  customPadding,
  customStyle,
  customWidth,
  disabled,
  displayLikeField,
  fullWidth,
  errorText,
  helperText,
  id,
  isLabelInline,
  label,
  isRequired,
  noWrap,
  onClick,
  spacing,
  willDelete,
  withBorder,
  withDivider,
  withLabel,
  ...rest
}) => (
  <LabelWrapper
    bottomBorder={bottomBorder}
    className={cn(classes.labelWrapper, { bottomBorder, 'has-click': onClick })}
    customCol={customCol}
    customMargin={customMargin}
    customPadding={customPadding}
    customWidth={customWidth}
    disabled={disabled}
    fullWidth={fullWidth}
    errorText={errorText}
    helperText={helperText}
    id={id}
    isLabelInline={isLabelInline}
    label={label}
    notWrapper={displayLikeField}
    noWrap={noWrap}
    onClick={onClick}
    spacing={spacing}
    willDelete={willDelete}
    withBorder={withBorder}
    withDivider={withDivider}
    isRequired={isRequired}
    {...rest}
  >
    <div
      className={cn(
        {
          [classes.fieldDisplay]: displayLikeField,
          'has-click': onClick,
          fullWidth,
          willDelete,
          withBorder,
          withLabel,
          disabled,
        },
        classes.text,
        'field-text',
        className
      )}
      style={customWidth ? { width: `${customWidth}px`, customStyle } : customStyle}
    >
      {children}
    </div>
  </LabelWrapper>
)

FieldText.defaultProps = {
  bottomBorder: false,
  fullWidth: true,
  withBorder: false,
}

const FieldTextComponent = withStyles(styles)(FieldText)
FieldTextComponent.displayName = 'FieldText'
export default FieldTextComponent
